<mat-progress-bar *ngIf="loading.value" mode="indeterminate" />
<mat-card class="cardWithShadow">

    <!-- Skeleton -->
    <div *ngIf="loading.value;" class="p-32">
        <ngx-skeleton-loader count="8" [theme]="{height: '30px'}" />
    </div>

    <!-- No Data -->
    <div *ngIf="!loading.value && !dataLength">
        <app-no-data *ngIf="!dataLength" />
    </div>


    <table mat-table matSort [dataSource]="dataTable.data"
        class="no-wrap m-t-0 v-middle w-100 {{hideData() ? 'd-none' : ''}}">

        <!-- Type -->
        <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
                <i-tabler name="bolt" matTooltip="Consumer" *ngIf="element.sites_type_id === 'CONSUMER'"></i-tabler>
                <i-tabler name="solar-panel" matTooltip="Producer"
                    *ngIf="element.sites_type_id === 'PRODUCER'"></i-tabler>
                <i-tabler name="solar-electricity" matTooltip="Prosumer"
                    *ngIf="element.sites_type_id === 'PROSUMER'"></i-tabler>
            </td>
        </ng-container>

        <!-- Site Type -->
        <ng-container matColumnDef="site_profile">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
                <i-tabler name="home-2" *ngIf="element.profile_type_id === 'Residenziale'"></i-tabler>
                <i-tabler name="building" *ngIf="element.profile_type_id === 'Ufficio'"></i-tabler>
                <i-tabler name="building-factory" *ngIf="element.profile_type_id === 'Industria'"></i-tabler>
            </td>
        </ng-container>

        <!-- Name -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Denominazione </th>
            <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container>

        <!-- Address -->
        <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef>Indirizzo</th>
            <td mat-cell *matCellDef="let element"> {{element.address}}, {{element.civic}} </td>
        </ng-container>

        <!-- City -->
        <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef> Citt&agrave; </th>
            <td mat-cell *matCellDef="let element"> {{element.cap}} {{element.city}} ({{element.province}}) </td>
        </ng-container>

        <!-- City -->
        <ng-container matColumnDef="cer">
            <th mat-header-cell *matHeaderCellDef> Cer di appartenenza </th>
            <td mat-cell *matCellDef="let element"><a [routerLink]="['/administration/cer', element.cer_id]"
                    routerLinkActive="router-link-active"> {{element.cerDetails.description}} </a></td>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Stato </th>
            <td mat-cell *matCellDef="let element">
                <app-status-label *ngIf="element.enabled" [text]="statuses.active.text"
                    [color]="statuses.active.color"></app-status-label>
                <app-status-label *ngIf="!element.enabled" [text]="statuses.unactive.text"
                    [color]="statuses.unactive.color"></app-status-label>
            </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Azioni </th>
            <td mat-cell *matCellDef="let element">
                <a mat-icon-button [routerLink]="['/administration/site', element.id]">
                    <i-tabler name="file-pencil" class="icon-25 text-primary"></i-tabler>
                </a>
                <button mat-icon-button (click)="delete(element.id)">
                    <i-tabler name="trash" class="icon-25 text-error"></i-tabler>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" style="background-color: #f1f1f1;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">Nessun dato trovato per il filtro impostato</td>
        </tr>
    </table>

    <mat-paginator *ngIf="dataLength && pagination" [pageSizeOptions]="[10, 25, 50]" [length]="dataLength"
        [pageSize]="pageSize" showFirstLastButtons (page)="handlePageEvent($event)" />
</mat-card>

<!-- Row shown when there is no matching data. -->
<ng-template class="mat-row" #matNoDataRow>
    <div colspan="4">Nessun dato per i filtri impostati</div>
</ng-template>